import GeneralListPage from './general-list-page';

export default GeneralListPage;